/**
 * useTrackVisit — fires POST /api/analytics/visit whenever the URL contains
 * UTM parameters. Anonymous + fire-and-forget. Wired once at the app root so
 * every route change is captured.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

export function useTrackVisit() {
  const location = useLocation();

  useEffect(() => {
    // Only fire when at least one utm_* param is present — quiet pings
    // would waste backend writes.
    const params = new URLSearchParams(location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v.slice(0, 80);
    });
    if (Object.keys(utm).length === 0) return;
    api
      .post("/analytics/visit", {
        ...utm,
        path: location.pathname,
        referrer: typeof document !== "undefined" ? document.referrer.slice(0, 300) : "",
      })
      .catch(() => {}); // Don't surface analytics failures to the user.
  }, [location.search, location.pathname]);
}
